// Zentrale Auflösung der Sketchfab-Links pro Artefakt — aus den Annotation-
// Label-States (Feld iFrameUrl), gekeyt nach Label-Id (= AnnotationId).
//
// WARUM aus den Labels und nicht aus den Artefakt-Arrays (stateArtefacts.jsx
// "Url"): dort sind viele Urls Platzhalter (z.B. mehrfach dasselbe
// 734fd10…-Modell) oder leer. Die Label-iFrameUrls sind die gepflegte,
// korrekte Quelle. Der Desktop-Pfad nutzte sie schon; auf Mobile öffnete der
// Direktklick fälschlich die Artefakt-Array-Url → falsches Modell.
//
// Sowohl Label-Klick (AnnotationId = Label.Id) als auch Direktklick
// (AnnotationId = "Annotation_" + titel) treffen dieselben Label-Ids.

import * as salzabbau from "../Themes/Salzabbau/states/stateSalzabbauLabels";
import * as holzarbeit from "../Themes/Holzarbeit/states/stateHolzarbeitLabels";
import * as menschen from "../Themes/Menschen/states/stateMenschenLabels";
import * as handelswege from "../Themes/Handelswege/states/stateHandelswegeLabels";
import * as mdrAnno from "../Themes/MuseenDerRegion/states/stateMDRAnnotationLabels";
import * as mdr from "../Themes/MuseenDerRegion/states/stateMdrLabels";

const modules = [salzabbau, holzarbeit, menschen, handelswege, mdrAnno, mdr];

const SKETCHFAB_BY_ANNOTATION_ID = {};
for (const mod of modules) {
  for (const exported of Object.values(mod)) {
    if (!Array.isArray(exported)) continue;
    for (const label of exported) {
      if (label && label.Id && label.iFrameUrl) {
        SKETCHFAB_BY_ANNOTATION_ID[label.Id] = label.iFrameUrl;
      }
    }
  }
}

// Liefert die (Embed-)Sketchfab-URL für eine AnnotationId, oder "" wenn kein
// echter Link hinterlegt ist (dann zeigt der Button nichts an).
export function getSketchfabUrl(annotationId) {
  return SKETCHFAB_BY_ANNOTATION_ID[annotationId] || "";
}
